/** "Which case is this?": the drafter's candidates, with why each was picked. */
import { AlertCircle, ArrowRight } from "lucide-react";
import type { FC } from "react";

import type { MatchCandidate } from "../types";
import { CaseDot } from "./CasePicker";

type Props = {
  candidates: readonly MatchCandidate[];
  onPick: (candidate: MatchCandidate) => void;
};

export const CandidateList: FC<Props> = ({ candidates, onPick }) => {
  if (!candidates.length) return null;
  const why =
    candidates.length > 1
      ? "This could be more than one case. Which one?"
      : "This looks like it belongs here:";
  return (
    <div
      className="flex flex-col gap-2 rounded-lg border border-line-2 bg-warn-soft p-2.5"
      data-testid="candidate-list"
    >
      <span className="flex items-center gap-1.5 text-sm font-medium">
        <AlertCircle className="size-3.5 text-warn" />
        {why}
      </span>
      <span className="flex flex-col gap-1.5">
        {candidates.map((c) => (
          <button
            key={c.individual_id}
            type="button"
            className="flex items-center gap-2.5 rounded-md border border-line-2 bg-surface px-2 py-1.5 text-left hover:bg-fill-2"
            onClick={(e) => {
              e.stopPropagation();
              onPick(c);
            }}
          >
            <CaseDot id={c.individual_id} />
            <span className="max-w-[45%] truncate text-sm font-medium">
              {c.label}
            </span>
            <span className="flex-1 truncate text-sm text-fg-3">
              {c.reason}
            </span>
            <span className="text-sm text-fg-3 tabular-nums">
              {Math.round(c.score * 100)}% match
            </span>
            <ArrowRight className="size-3 text-fg-3" />
          </button>
        ))}
      </span>
    </div>
  );
};
